import React from 'react';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import ConsultationCTA from '../../components/ui/ConsultationCTA';
import CompanyMission from './components/CompanyMission';
import CompanyHistory from './components/CompanyHistory';
import CoreValues from './components/CoreValues';
import CompanyStatistics from './components/CompanyStatistics';
import CompanyCulture from './components/CompanyCulture';
import IndustryRecognition from './components/IndustryRecognition';
import VisionStatement from './components/VisionStatement';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="max-w-7xl mx-auto px-6 py-8">
        <Breadcrumb />
        
        {/* Page Content */}
        <div className="space-y-16">
          <CompanyMission />
          <CompanyHistory />
          <CoreValues />
          <CompanyStatistics />
          <CompanyCulture />
          <IndustryRecognition />
          <VisionStatement />
          
          {/* Consultation CTA */}
          <ConsultationCTA 
            variant="banner" 
            context="about"
            className="mt-16"
          />
        </div>
      </main>
      
      {/* Floating CTA */}
      <ConsultationCTA variant="floating" context="about" />
    </div>
  );
};

export default AboutUs;